export const CUSTOM_MATERIAL_ICON_NAMES: string[] = [
    'add',
    'ai',
    'apple',
    'arrow-clockwise',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-rotate-left',
    'arrow-rotate-right',
    'arrow-up',
    'assignment-turned-in',
    'bars',
    'basket',
    'bell',
    'box-seam',
    'box',
    'brush',
    'building',
    'buildings',
    'bus-front',
    'calendar',
    'offer',
    'calendar-check',
    'calendar-week',
    'chart-simple',
    'check-all',
    'check-circle-broken',
    'check-circle',
    'check',
    'chevron-bottom',
    'chevron-left',
    'chevron-right',
    'chevron-selector',
    'clips',
    'clock',
    'close',
    'close-circle',
    'cloud',
    'coin-dollar',
    'collapse',
    'copy',
    'crypto',
    'custom',
    'database',
    'distribute-horizontal',
    'distribute-vertical',
    'dot-circle',
    'dot',
    'download',
    'easel',
    'edit-note',
    'ellipsis',
    'expand',
    'exclamation-triangle',
    'exclamation-circle',
    'eye-slash',
    'eye',
    'feedback',
    'file',
    'filter',
    'fork-and-knife',
    'format-text',
    'gear',
    'globe',
    'google',
    'graduation-hat',
    'house',
    'html',
    'image-slash',
    'image',
    'images',
    'info-circle',
    'layer-group',
    'lightning',
    'logout',
    'lotus',
    'map-pin',
    'money-bill-coin',
    'monitor',
    'moon-stars',
    'pause',
    'pencil-square',
    'pencil',
    'play',
    'pollution',
    'prescription',
    'rotate-left',
    'question',
    'search',
    'send',
    'sort-ascending',
    'sort-descending',
    'square-play',
    'stopwatch',
    'store',
    'sun',
    'trash',
    'upload',
    'user',
    'users',
    'venue',
    'warning-triangle',
    'warning',
    'zoom-in',
    'zoom-out',
];
